import { createNaturalDivisionTask, randInt, largerSplitExplanation } from "./sharedNaturalDivision";

function pickData() {
  const b = randInt(2, 9);
  const firstQuotient = randInt(2, 8) * 10;
  const secondQuotient = randInt(2, 9);
  const result = firstQuotient + secondQuotient;
  const firstPart = b * firstQuotient;
  const secondPart = b * secondQuotient;
  const a = firstPart + secondPart;
  return { a, b, firstPart, secondPart, firstQuotient, secondQuotient, result };
}

const mod = createNaturalDivisionTask({
  type: "NaturalDivLargerSplitTask",
  pickData,
  explain: largerSplitExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
